module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa4 bb b-theme bw3 br20 tc bg-white shadow-theme h-100 flex flex-column",
    class: _vm.classlist
  }, [_c('div', {
    staticClass: "f3 mb3 flex justify-center items-center color-theme"
  }, [(_vm.icon) ? _c('div', {
    staticClass: "mr2 icon",
    domProps: {
      "innerHTML": _vm._s(_vm.icon)
    }
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.header) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3 silver flex-grow flex-column flex justify-around",
    class: _vm.compact ? 'f6' : ''
  }, [_vm._v("\n    " + _vm._s(_vm.subheader) + "\n  ")]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72168ef5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tile.vue
// module id = 1275
// module chunks = 0